import { Children } from "react";
import type { ReactNode } from "react";
import { Box, Divider } from "@mui/material";
import type { SxProps, Theme } from "@mui/material";
export function TopBar({
  children,
  align,
  sx = {},
}: {
  children: ReactNode;
  align?: "center" | "left";
  sx?: SxProps<Theme>;
}) {
  const content = Children.toArray(children)
    .flatMap((child, index) => [
      <Divider
        key={`divider${index}`}
        sx={{ mx: 1 }}
        orientation="vertical"
        flexItem
      />,
      child,
    ])
    .slice(1);
  return (
    <Box
      sx={[
        {
          py: 0.8,
          px: 2,
          background: "white",
          borderBottom: 1,
          borderColor: "rgba(0, 0, 0, 0.42)",
          display: "flex",
          alignItems: "center",
          flexWrap: "wrap",
          justifyContent: align === "center" ? "center" : "flex-start",
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {content}
    </Box>
  );
}
